import { type FileData, createZip } from './create-zip';

export type BatchDownloadZipParameters = {
  downloadFile: (url: string) => Promise<Blob>;
  files: FileDownloadParameters[];
  zipFileName?: string;
};

export type FileDownloadParameters = {
  fileName: string;
  url: string;
};

export const batchDownloadZip = async ({
  downloadFile,
  files,
  zipFileName = 'download.zip',
}: BatchDownloadZipParameters) => {
  const downloadPromises = files.map(async (file) => ({
    data: await downloadFile(file.url),
    fileName: file.fileName,
  }));

  const fileDataResults: FileData[] = await Promise.all(downloadPromises);

  return createZip({ files: fileDataResults, zipFileName });
};
